import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from "@angular/core";
import { Router } from "@angular/router";

import { Connection } from "../../../../../../components/subscription-detail/connection/connection";
import { Networkgraph } from "../../../../../../components/subscription-detail/networkgraph/networkgraph";
import { PageTabComponent } from "../../../../../../components/subscription-detail/page-tab/page-tab";
import {
  PAGE_TAB_CONFIG_DEFAULT,
  TabConfig,
} from "../../../../../../components/subscription-detail/page-tab/tab-config";
import { SubscriptionDetailTab } from "../../../../../../components/subscription-detail/page-tab/tab-types";
import { LightPathRedundantSubscriptionDetails, LightPathSubscriptionDetails } from "../../../../types";

@Component({
  selector: "lighpath-config",
  templateUrl: "lightpath-config.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PageTabComponent, Networkgraph, Connection],
})
export class LightpathConfigComponent {
  private readonly router = inject(Router);

  protected subscription = input.required<LightPathSubscriptionDetails | LightPathRedundantSubscriptionDetails>();
  protected activeTab = input.required<SubscriptionDetailTab>();
  protected tabConfig = signal<TabConfig<SubscriptionDetailTab>[]>(PAGE_TAB_CONFIG_DEFAULT);
  protected productType = computed(() => this.subscription().product.type);
  protected topology = computed(() => this.subscription().topology);
  protected circuits = computed(() => this.subscription().circuits);

  changeActiveTab(tabName: SubscriptionDetailTab) {
    this.router.navigate([
      "/diensten/LightPath",
      this.subscription().product.tag,
      this.subscription().subscriptionId,
      tabName,
    ]);
  }

  protected isGraphicViewTabActive = computed(() => this.activeTab() === SubscriptionDetailTab.GRAPHIC_VIEW);
  protected isConfigTabActive = computed(() => this.activeTab() === SubscriptionDetailTab.CONFIG);
}
